import React from 'react';
import logo from './assets/img/logo.png';
import whats from './assets/img/whatsapp.png';
import mess from './assets/img/messenger.png';
import './App.css';

function App() {
  return (
    <div className="App">
     
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />

        <p
          className="App-contact"
          rel="noopener noreferrer"
        >
          <i>(+244) 938 690 039</i>
        </p>

        <p
          className="App-link"
          rel="noopener noreferrer"
        >
          <i>Luanda, Angola</i>
        </p>
      </header>
      <div className="whatsapp-fixo">
          <a href="https://web.whatsapp.com/send?phone=244938690039&text=Olá,%20deixe%20a%20sua%20mensagem." target="blank">
              <img src={whats} width="70" height="70" alt="Fale Conosco pelo WhatsApp"/> 
          </a>
      </div>
      <div className="whatsapp-mes">
          <a href="https://m.me/mesosolutions" target="blank">
              <img src={mess} width="70" height="70" alt="Fale Conosco pelo WhatsApp"/> 
          </a>
      </div>
    </div>
  );
}

export default App;
